import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import LoginResetPopup from "../../Auth/Popups/LoginResetPopup";
import AccAccordion from "./AccAccordion";
import InitialNotificationPopup from "./Withdraw/InitialNotificationPopup";
import FreespinBalance from "../../Auth/Freespin/Balance";
import { getUserInformation } from '../../Auth/Utils';
import GameIframeNotLogged from "./IframeNotLogged";
import GameIframeLogged from "./IframeLogged";
import StoreContext from "../../shared/сontext/StoreContext";
import PlayForFreeGame from "./PlayForFreeGame";
import RealMoneyPrompt from "./RealMoneyPrompt";

const FreespinGame = ({ h1, gameCode, gameName }) => {
  const value = useContext(StoreContext);
  const { username, logoutFunc } = value;
  const [loadingGame, setLoadingGame] = useState(true);
  const [userInformation, setUserInformation] = useState({});
  /* useEffect to prevent blinking of username-related stuff */
  useEffect(() => {
    let mounted = true;
    getUserInformation().then(data => {
      if (mounted) {
        setUserInformation(data);
        setLoadingGame(false);
      }
    });
    return () => {
      mounted = false;
    }
  }, [username]);
  return (
    <>
      <div className="game-wrapper">
        <div className="top-header mobile-reverse">
          <h1 className="entry-title">
            <span className="game-title">เกม {h1}</span>
          </h1>
          {userInformation.username && !loadingGame ?
            <>
              <div className="top-auth-block">
                <FreespinBalance/>
                <AccAccordion gameName={gameName} userName={userInformation.username} logoutFunc={logoutFunc}/>
                <InitialNotificationPopup/>
              </div>
            </> :
            <>
              <div className="auth-wrapper-not-logged auth-wrapper">
                <LoginResetPopup buttonClass="freespin-login-game-page-top button" buttonText="เข้าสู่ระบบ"/>
                <a className="freespin-reg-game-page-top button-white register-button"
                   href="/register/?register_type=onsitegames">
                  <span>สมัครสมาชิก</span>
                </a>
              </div>
            </>
          }
        </div>
        {userInformation.username && !loadingGame ?
          <GameIframeLogged gameCode={gameCode} username={username}/> :
          <GameIframeNotLogged />
        }
      </div>
      <RealMoneyPrompt/>
      <PlayForFreeGame exclCode={gameCode}/>
    </>
  );
};

export default FreespinGame;

FreespinGame.propTypes = {
  h1: PropTypes.string,
  gameCode: PropTypes.string,
  gameName: PropTypes.string,
};

